import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcFile = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 61,
	height: 60,
	viewBox: "0 0 61 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8C12 7.17157 12.6716 6.5 13.5 6.5H30.5H39.1202C39.5581 6.5 39.9741 6.69134 40.2591 7.02381L45.3221 12.9307L48.7131 17.5933C48.8996 17.8497 49 18.1585 49 18.4756V30V52C49 52.8284 48.3284 53.5 47.5 53.5H13.5C12.6716 53.5 12 52.8284 12 52V8Z",
			stroke: "#03A65B",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 24.5H40.5",
			stroke: "#03A65B",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 32H40.5",
			stroke: "#03A65B",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.5 40H33.5",
			stroke: "#03A65B",
			strokeWidth: 3
		})
	]
});
const ForwardRef = forwardRef(SvgIcFile);
export default ForwardRef;
